module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Multi")]), _vm._v(" "), _c('multi-example'), _vm._v(" "), _c('h3', [_vm._v("Multi with custom attribute to allow custom css")]), _vm._v(" "), _c('custom-multi-example'), _vm._v(" "), _c('h3', [_vm._v("With ajax")]), _vm._v(" "), _c('with-ajax'), _vm._v(" "), _c('h3', [_vm._v("With missing value")]), _vm._v(" "), _c('with-missing-example')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0e5e228e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sample/Multi/Multi.vue
// module id = 381
// module chunks = 2